import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '關於我們', href: '#about', isExternal: false },
    { label: '服務項目', href: '#services', isExternal: false },
    { label: '服務區域', href: '/service-area', isExternal: true },
    { label: '最新消息', href: '/blog', isExternal: true },
    { label: '聯絡我們', href: '#contact', isExternal: false },
  ];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/299aafac10f17bf7dd171fda07c097c7.png" 
              alt="前金日間照顧中心" 
              className="w-12 h-12 object-contain"
            />
            <h1 className="text-lg font-bold text-baby-blue-600">前金日間照顧中心</h1>
          </div>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              item.isExternal ? (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`text-sm font-medium transition-colors cursor-pointer ${
                    isScrolled ? 'text-baby-blue-600 hover:text-baby-blue-400' : 'text-white hover:text-cream-200'
                  }`}
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.label}
                  onClick={() => scrollToSection(item.href)}
                  className={`text-sm font-medium transition-colors cursor-pointer ${
                    isScrolled ? 'text-baby-blue-600 hover:text-baby-blue-400' : 'text-white hover:text-cream-200'
                  }`}
                >
                  {item.label}
                </button>
              )
            ))}
          </div>

          <button
            onClick={() => scrollToSection('#contact')}
            className="hidden md:flex items-center gap-2 bg-cream-300 hover:bg-cream-400 text-baby-blue-600 px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            立即諮詢
          </button>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-2xl ${isScrolled ? 'text-baby-blue-600' : 'text-white'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 bg-white rounded-2xl shadow-lg p-4">
            {navItems.map((item) => (
              item.isExternal ? (
                <Link
                  key={item.label}
                  to={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block w-full text-left px-4 py-3 text-baby-blue-600 hover:bg-baby-blue-50 rounded-lg transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.label}
                  onClick={() => scrollToSection(item.href)}
                  className="block w-full text-left px-4 py-3 text-baby-blue-600 hover:bg-baby-blue-50 rounded-lg transition-colors cursor-pointer"
                >
                  {item.label}
                </button>
              )
            ))}
            <button
              onClick={() => scrollToSection('#contact')}
              className="w-full mt-2 bg-cream-300 text-baby-blue-600 px-4 py-3 rounded-lg font-medium cursor-pointer whitespace-nowrap"
            >
              立即諮詢
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
